import type { Modification } from '@carboncopyco/types';
import constate from 'constate';
import { useEditTransactionRuleForm } from './useEditTransactionRuleForm';
import {
  type WizardState,
  useEditTransactionRuleReducer,
} from './useEditTransactionRuleReducer';

export interface UseEditTransactionRule {
  transactionModifications: Modification<'transaction_rule'>[];
  onLearnMoreClick?: (url: string) => void;
  transactionRule: WizardState['transactionRule'];
  cancelEdit: () => void;
  submitEdit: (
    transactionRule: WizardState['transactionRule'],
    refresh?: boolean
  ) => Promise<unknown>;
}

const useEditTransactionRule = ({
  onLearnMoreClick,
  transactionRule,
  transactionModifications,
  cancelEdit,
  submitEdit,
}: UseEditTransactionRule) => {
  const reducer = useEditTransactionRuleReducer({
    transactionRule,
  });
  const form = useEditTransactionRuleForm({
    transactionRule,
    transactionModifications,
  });

  return {
    onLearnMoreClick,
    cancelEdit,
    submitEdit,
    form,
    ...reducer,
  };
};

export const [EditTransactionRuleProvider, useEditTransactionRuleContext] =
  constate(useEditTransactionRule);
